<div class="footer__block">
  <div class="footer__heading heading heading_small">Policies</div>
  <div class="footer__links">
    <a routerLink="/terms-of-use">Terms of Use</a>
    <a routerLink="/privacy-policy">Privacy Policy</a>
    <a routerLink="/refund-policy">Refund Policy</a>
    <a routerLink="/licensing-policy">Licensing Policy</a>
    <a routerLink="/cookie-policy">Cookie Policy</a>
  </div>
</div>
